module.exports = __webpack_public_path__ + "img/wangjing_2.f105644d.jpg";